import { Component, Input, OnInit } from '@angular/core';
import { PersianTitlesService } from '../../../core/services/persian-titles.service';
import { WorkshopModel } from '../../../features/workshop/models/workshop.model';
import { CommonModule } from '@angular/common';
import {
  SharedWorkshopCardComponent,
  SharedWorkshopCardAction,
  SharedWorkshopCardRow,
} from 'src/app/shared/components/shared-workshop-card/shared-workshop-card.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-workshop-row-card',
  templateUrl: './workshop-row-card.component.html',
  styleUrls: ['./workshop-row-card.component.css'],
  standalone: true,
  imports: [CommonModule, SharedWorkshopCardComponent, TranslateModule],
})
export class WorkshopRowCardComponent implements OnInit {
  @Input('workshop') workshop!: WorkshopModel;

  // Labels
  teacherLabel: string = '';
  holdingTypeLabel: string = '';
  holdingDateLabel: string = '';
  locationLabel: string = '';

  cardActions: SharedWorkshopCardAction[] = [];
  cardRows: SharedWorkshopCardRow[] = [];

  constructor(
    private persianTitlesService: PersianTitlesService,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.initLabel();
    this.initRows();
    this.initActions();
  }

  private initLabel() {
    this.teacherLabel = this.persianTitlesService.Items.Teacher;
    this.holdingDateLabel = this.persianTitlesService.Items.HoldingDate;
    this.holdingTypeLabel = this.persianTitlesService.Items.HoldingType;
    this.locationLabel = this.persianTitlesService.Items.Location;
  }

  private initRows() {
    this.cardRows = [
      {
        icon: 'lucideUser',
        title: this.teacherLabel,
        value: this.workshop.teacherFullName,
      },
      {
        icon: 'lucideCalendar',
        title: this.holdingDateLabel,
        value: this.workshop.holdingDateJalali,
        badge:
          this.workshop.daysLeft > 0
            ? this.workshop.daysLeft + ' روز دیگر'
            : undefined,
      },
      {
        icon: 'lucideLayers',
        title: this.holdingTypeLabel,
        value: this.workshop.holdingTypeTitle,
      },
    ];
    if (this.workshop.locationTitle?.length) {
      this.cardRows.push({
        icon: 'lucideMapPin',
        title: this.locationLabel,
        value: this.workshop.locationTitle,
      });
    }
  }

  private initActions() {
    this.cardActions = [
      ...(this.workshop?.googleCalendarNewEventUrl
        ? [
            {
              type: 'link',
              label: this.translateService.instant('labels.addToCalendar'),
              severity: 'text',
              outlined: false,
              icon: 'fa fa-calendar',
              link: this.workshop.googleCalendarNewEventUrl,
            },
          ]
        : []),
    ] as SharedWorkshopCardAction[];
  }
}
